exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-zahtjev-primljen-js": () => import("./../../../src/pages/zahtjev-primljen.js" /* webpackChunkName: "component---src-pages-zahtjev-primljen-js" */),
  "component---src-pages-zahtjev-primljen-postojeci-js": () => import("./../../../src/pages/zahtjev-primljen-postojeci.js" /* webpackChunkName: "component---src-pages-zahtjev-primljen-postojeci-js" */)
}

